// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ion-list {
  background: var(--ion-color-background);
}
:host .family-tab-bar {
  display: block;
  margin: 0 20px var(--space-sm);
}
:host flw-breadcrumb {
  display: block;
  padding: 0 var(--space-xl);
  margin: var(--space-md) 0;
}
:host flw-family-selector {
  display: block;
  padding: 0 20px var(--space-sm);
}
:host .services-selector-list,
:host .packs-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0 20px var(--space-sm);
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/wizard/family-service-list/family-service-list.component.scss"],"names":[],"mappings":"AACI;EACI,uCAAA;AAAR;AAGI;EACI,cAAA;EACA,8BAAA;AADR;AAII;EACI,cAAA;EACA,0BAAA;EACA,yBAAA;AAFR;AAKI;EACI,cAAA;EACA,+BAAA;AAHR;AAMI;;EAEI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,+BAAA;AAJR","sourcesContent":[":host {\r\n    ion-list{\r\n        background: var(--ion-color-background);\r\n    }\r\n\r\n    .family-tab-bar {\r\n        display: block;\r\n        margin: 0 20px var(--space-sm);\r\n    }\r\n\r\n    flw-breadcrumb {\r\n        display: block;\r\n        padding: 0 var(--space-xl);\r\n        margin: var(--space-md) 0;\r\n    }\r\n\r\n    flw-family-selector {\r\n        display: block;\r\n        padding: 0 20px var(--space-sm);\r\n    }\r\n\r\n    .services-selector-list,\r\n    .packs-list {\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 12px;\r\n        padding: 0 20px var(--space-sm);\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
